export const subIsActive = (path: string, $route: any): boolean => {
  const paths = Array.isArray(path) ? path : [path];

  return paths.some((p) => {
    return $route.path.indexOf(p) === 0;
  });
};
